import React from 'react';
import styles from './PrimaryButton.module.css';

function PrimaryButton({
  children,
  onClick,
  type = 'button',
  disabled = false,
  className = '',
  ariaLabel
}) {
  return (
    <button
      type={type}
      className={`${styles.primaryButton} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
}

export default PrimaryButton;
